import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

import { store } from '@/store'
import { mapState } from 'vuex'
import { API_URL, DATA_URL, BASE_URL } from "@/common/config";

import { Log } from '@/services/log.service'
import { Navigation } from '@/services/navigation.service'

export const ApiService = new Vue({

	store,

	data: () => {
		return {
		}
	},

	computed: {
		...mapState(['globals']),
	},

	methods: {

		init() {
			Vue.use(VueAxios, axios);
			Vue.axios.defaults.baseURL = API_URL;
		},

		setHeader() {
			/*
			Vue.axios.defaults.headers.common[
				"Authorization"
			] = `Token ${JwtService.getToken()}`;
			*/
		},

		query(resource, params) {

			return new Promise(function(resolve, reject) {

				var xhr = new XMLHttpRequest();
				xhr.open('get', resource, true);
				xhr.responseType = 'text';
				xhr.onload = function() {
					var status = xhr.status;
					if (status == 200 || status == 0) {
						resolve(xhr.response);
					} else {
						reject(false);
					}
				};
				xhr.onerror = function() {
					reject();
				}
				xhr.send();
			});
		},

		get(resource, slug = "") {
			return Vue.axios.get(`${resource}/${slug}`).catch(error => {
				throw new Error(`ApiService ${error}`);
			});
		},

		post(resource, params) {
			return Vue.axios.post(`${resource}`, params);
		},

		update(resource, slug, params) {
			return Vue.axios.put(`${resource}/${slug}`, params);
		},

		put(resource, params) {
			return Vue.axios.put(`${resource}`, params);
		},

		delete(resource) {
			return Vue.axios.delete(resource).catch(error => {
				Log.ERROR('ApiService.delete()', 'resource', error);
			});
		},

		/**
		 * 	Eine absolute URL erzeugen
		 */
		absoluteUrl( url ) {
			return BASE_URL + url.replace(BASE_URL, '');
		},

		/**
		 * 	Ein Produkt laden
		 */
		loadProductData( product ) {
			return new Promise((resolve, reject) => {
				var url = DATA_URL + `product_infos/${product}.json`;
				this.query( url ).then(( result ) => {
					var data = this.parseResultData( result );
					if (data === false) {
						Log.ERROR('ApiService.loadProductData()', 'invalid data: ' + url, result);
						reject();
					}
					resolve({data:data});
				}).catch(() => {
					reject();
				});
			});
		},

		/**
		 * 	Settings laden.
		 */
		loadSettings() {

			return new Promise((resolve, reject) => {
				var url = DATA_URL + 'presets.json';
				this.query( url ).then(( result ) => {
					var data = this.parseResultData( result );

					if (data === false) {
						Log.ERROR('ERROR ApiService.loadSettings()', 'invalid data', result);
						reject();
					}
					resolve({data:data});
				}).catch(() => {
					reject();
				});
			});
		},

		/**
		 * 	Navigation laden.
		 *
		 */
		loadNavigation() {

			return new Promise((resolve, reject) => {
				var url = DATA_URL + 'navigation.json';
				this.query( url ).then(( result ) => {
					var data = this.parseResultData( result );

					if (data === false) {
						Log.ERROR('ERROR ApiService.loadNavigation()', 'invalid data', result);
						reject();
					}

					data = Navigation.parseData( data );
					resolve({data:data});
				}).catch(() => {
					reject();
				});
			});
		},

		/**
		 *	Daten aus dem JSON parsen
		 *
		 */
		parseResultData( data ) {

			// Einfacher String statt JSON? ({a:1} statt {"a":"1"})
			data = this.parseJsonString( data );

			if (!data) return false;

			// Umwandeln der Daten
			return data;
		},

		/**
		 * 	Prüft, ob ein String im JSON-Format vorliegt.
		 *
		 */
		isJson ( str ) {
			if (typeof data != 'string') return false;
			var result = false;
			try {
				result = JSON.parse(str);
			} catch (e) {
				result = false;
			}
			return result;
		},

		/**
		 * 	Wandeln String ("{a:1}") oder JSON ('{"a":"1"}') in ein
		 *	normales JS-Object ({a:1}) um.
		 *
		 */
		parseJsonString( data ) {
			if (data === '') return {};
			if (typeof data == 'string') {
				var obj = this.isJson( data );
				if (obj) return obj;
				try {
					eval(`data = ${data}`);
				} catch (e) {
					Log.ERROR('ERROR ApiService.parseJsonString()', 'invalid data', data);
					data = false;
				}
			}
			return data;
		},

		/**
		 * 	URL im Browser ändern, ohne einen Redirect auszulösen.
		 * 	Sichert, dass beim Reload der Seite nach einem Pick nicht
		 * 	der gleiche Pick direkt wieder hinzugefügt wird.
		 *
		 * 	Beispiel:
		 * 	https://staging.picka.blue/p/30/#/mypicks
		 * 	wird geändert zu:
		 * 	https://staging.picka.blue/#/mypicks
		 *
		 */
		rebaseURL () {
			if (!window.history.pushState) return false;
			setTimeout(() => {
				window.history.pushState('', '', '/' + window.location.hash);
			}, 500);
		},

	}
});
